import { BaseModel } from '../../base/base-model'

/**
 * @memberOf loavies.models.transaction
 * @constructor
 */
export class IntegrationTransactionQueryModel extends BaseModel {
  /**
   * https://www.sharetribe.com/api-reference/integration.html#query-transactions
   * @param {string} [createdAtStart] The timestamp must be in ISO 8601 format.
   * @param {string} [createdAtEnd] The timestamp must be in ISO 8601 format.
   * @param {string} [userId] id of either provider or customer
   * @param {string} [customerId]
   * @param {string} [providerId]
   * @param {string} [listingId]
   */
  constructor({
    createdAtStart,
    createdAtEnd,
    userId,
    customerId,
    providerId,
    listingId,
  }) {
    super()

    /** @type {string} */
    if (!this.isUndefined(createdAtStart)) this.createdAtStart = createdAtStart

    /** @type {string} */
    if (!this.isUndefined(createdAtEnd)) this.createdAtEnd = createdAtEnd

    /** @type {string} */
    if (!this.isUndefined(userId))  this.userId = userId

    /** @type {string} */
    if (!this.isUndefined(customerId)) this.customerId = customerId

    /** @type {string} */
    if (!this.isUndefined(providerId)) this.providerId = providerId

    /** @type {string} */
    if (!this.isUndefined(listingId))  this.listingId = listingId
  }
}
